/**
 * GA4 helpers (no-op when gtag is not loaded).
 */

function gtagSafe(...args) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag(...args);
  }
}

export function trackEvent(eventName, params = {}) {
  gtagSafe("event", eventName, params);
}

export function trackOutboundClick({ url, label, storeSlug, couponId } = {}) {
  trackEvent("outbound_click", {
    link_url: url,
    link_text: label,
    store_slug: storeSlug,
    coupon_id: couponId,
  });
}

export function trackCouponCopy({ couponId, storeSlug, hasCode } = {}) {
  trackEvent("coupon_copy", {
    coupon_id: couponId,
    store_slug: storeSlug,
    has_code: hasCode ? "yes" : "no",
  });
}

export function trackSearch({ query, resultCount } = {}) {
  trackEvent("search", {
    search_term: query,
    result_count: resultCount,
  });
}
